import { Grid2Props } from '@mui/material';
import getViewsAbbreviated from '@zefr/style-guide/dist/ui/utils/strings/getViewsAbbreviated';
import React from 'react';
import TextGridItem from './TextGridItem';

export interface SpendGridItemProps extends Grid2Props {
  value?: number | React.ReactNode;
}

const SpendGridItem: React.FC<SpendGridItemProps> = ({ value, ...props }) => {
  return (
    <TextGridItem
      {...props}
      value={
        typeof value === 'number' || typeof value === 'undefined'
          ? `$${getViewsAbbreviated(value, true)}`
          : value
      }
      label={'Spend'}
      tooltipTitle={`Total campaign spend available estimated based on selected and excluded concepts and other campaign details`}
    />
  );
};

export default SpendGridItem;
